import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { IconDefinition } from './';
import { Button } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  root: {
    height: theme.styles.components.button.height
  },
  leftIcon: {
    marginRight: theme.spacing(),
    width: theme.styles.components.icon.width,
    height: theme.styles.components.icon.height
  },
  rightIcon: {
    marginLeft: theme.spacing(),
    width: theme.styles.components.icon.width,
    height: theme.styles.components.icon.height
  }
})

interface MyProps extends StyledProps {
  /** Boolean indicating whether the button should render as disabled */
  disabled?: boolean,
  /** Function to be called on Button Click */
  onClick: (e) => void,
  /** React component of an icon */
  icon?: IconDefinition
}


export class FlatButtonComponent extends React.Component<MyProps> {
  static defaultProps = {
    disabled: false,
    onClick:  () => {}
  }

  render() {
    const {props, props: {classes, icon, children, ...otherProps}} = this
    return (
      <Button classes={{root: classes.root}}
              {...otherProps}
              variant={'text'}
              color={'secondary'}
              disabled={props.disabled}
              onClick={props.onClick}>
        {icon && icon.component && icon.position === 'left' ? <div className={classes.leftIcon}>{icon.component}</div> : null}
        {children}
        {icon && icon.component && icon.position === 'right' ? <div className={classes.rightIcon}>{icon.component}</div> : null}
      </Button>
    )
  }
}

@(withStyles as any)(styles)
export class FlatButton extends FlatButtonComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/FlatButton.tsx